import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Clipboard } from '@angular/cdk/clipboard';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';

import { Project, ProjectTemplate } from 'app/modules/projects/projects.types';
import { EMAIL_PATTERN } from 'app/shared/Utils/common.utils';

@Component({
  selector: 'project-show-deal-email',
  templateUrl: './project-show-deal-email.component.html',
  styleUrls: ['./project-show-deal-email.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ProjectShowDealEmailComponent implements OnInit {
  projectForm: UntypedFormGroup;
  projectTemplates: ProjectTemplate<any>[];
  public uploadedFile: any;
  project: Project;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public matDialogRef: MatDialogRef<ProjectShowDealEmailComponent>,
    private _formBuilder: UntypedFormBuilder,
    private _clipboard: Clipboard,
    private _snackBar: MatSnackBar,
  ) {}

  ngOnInit(): void {
    this.projectForm = this._formBuilder.group({
      email: ['', [Validators.email, Validators.pattern(EMAIL_PATTERN)]],
    });

    this.project = this.data.project;
    this.projectForm.get('email').setValue(`deals+${this.project.id}@termsheetmail.com`);
    this.projectForm.disable();
  }

  /**
   * Discard the message
   */
  discard(): void {
    this.matDialogRef.close();
  }

  /**
   * Copy direct deal email address
   */
  copyDealEmailAddress(): void {
    this._clipboard.copy(`deals+${this.project.id}@termsheetmail.com`);
    this._snackBar.open('Email address copied. Use CTRL-V to paste.', '', {
      duration: 3000,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
    });
  }
}
